// import user from './user';
// import menu from './menu';
/**
 * 模拟数据mock
 *
 * mock是否开启模拟数据拦截
 * 注意：开启mock，影响文件下载。mock会将返回值格式化成json类型。
 */

// user({ mock: true });

// menu({ mock: true });
